import { AutoMap } from '@automapper/classes';
import { IsArray, IsDefined, IsOptional, IsString, IsUUID } from 'class-validator';
import { SiteDto } from './site.model';

export class AccountDto {
  @AutoMap()
  @IsUUID()
  @IsDefined()
  id: string;

  @IsUUID()
  @IsDefined()
  parentId: string;

  @IsString()
  @IsDefined()
  displayLabel: string;

  @IsUUID()
  @IsOptional()
  entityId?: string;

  @IsArray()
  @IsOptional()
  children?: SiteDto[];
}
